import React, { useState, memo } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Tabs } from '../ui/Tabs';
import { SaveIcon, PlusIcon, XIcon } from 'lucide-react';
export function ModelliSollecitiTab() {
  const [activeModel, setActiveModel] = useState('inScadenza');
  const [emailCopies, setEmailCopies] = useState({
    inScadenza: ['direttore@acme.it'],
    amichevole: ['direttore@acme.it'],
    formale: ['direttore@acme.it', 'amministrazione@acme.it'],
    duro: ['direttore@acme.it', 'amministrazione@acme.it', 'legale@acme.it'],
    pec: ['direttore@acme.it', 'amministrazione@acme.it', 'legale@acme.it']
  });
  const [newEmail, setNewEmail] = useState('');
  const [modelContents, setModelContents] = useState({
    inScadenza: `Gentile Cliente,
Con la presente desideriamo ricordarLe che la fattura n. [NUMERO_FATTURA] del [DATA_FATTURA] di importo pari a [IMPORTO_FATTURA] € scadrà in data [DATA_SCADENZA].
La preghiamo di predisporre quanto necessario per il pagamento entro la data di scadenza.
Per qualsiasi chiarimento, non esiti a contattarci.
Cordiali saluti,
[NOME_AZIENDA]`,
    amichevole: `Gentile Cliente,
Con la presente desideriamo ricordarLe che la fattura n. [NUMERO_FATTURA] del [DATA_FATTURA] di importo pari a [IMPORTO_FATTURA] € risulta non ancora saldata, nonostante sia scaduta in data [DATA_SCADENZA].
La preghiamo di provvedere al pagamento quanto prima o di contattarci se ritiene che ci sia stato un errore.
Cordiali saluti,
[NOME_AZIENDA]`,
    formale: `Gentile Cliente,
Nonostante il nostro precedente sollecito, la fattura n. [NUMERO_FATTURA] del [DATA_FATTURA] di importo pari a [IMPORTO_FATTURA] € risulta ancora non pagata.
La invitiamo a regolarizzare la Sua posizione entro e non oltre 7 giorni dalla presente comunicazione.
In caso di mancato riscontro, saremo costretti a procedere con un sollecito formale.
Cordiali saluti,
[NOME_AZIENDA]`,
    duro: `Spett.le [NOME_CLIENTE],
Nonostante i ripetuti solleciti, la fattura n. [NUMERO_FATTURA] del [DATA_FATTURA] di importo pari a [IMPORTO_FATTURA] € risulta ancora non pagata.
Con la presente La informiamo che, in assenza di pagamento entro e non oltre 3 giorni dalla presente comunicazione, saremo costretti ad avviare le procedure di recupero credito tramite i nostri legali, con aggravio di spese a Suo carico.
Distinti saluti,
[NOME_AZIENDA]`,
    pec: `DIFFIDA AD ADEMPIERE
(ex art. 1454 c.c.)
Spett.le [NOME_CLIENTE]
[INDIRIZZO_CLIENTE]
[CAP] [CITTA] [PROVINCIA]
P.IVA: [PIVA_CLIENTE]
C.F.: [CF_CLIENTE]
OGGETTO: Diffida ad adempiere - Fattura n. [NUMERO_FATTURA] del [DATA_FATTURA]
Con la presente, la scrivente società [NOME_AZIENDA], con sede in [INDIRIZZO_AZIENDA], P.IVA [PIVA_AZIENDA], in persona del legale rappresentante pro tempore,
PREMESSO CHE
- in data [DATA_FATTURA] la scrivente emetteva nei Vostri confronti la fattura n. [NUMERO_FATTURA] di importo pari a [IMPORTO_FATTURA] €;
- nonostante i ripetuti solleciti, tale fattura risulta a tutt'oggi non pagata;
DIFFIDA
la Vostra società ad adempiere al pagamento dell'importo dovuto entro e non oltre 15 giorni dal ricevimento della presente, avvertendo che, decorso inutilmente tale termine, il contratto si intenderà risolto di diritto ai sensi dell'art. 1454 c.c. e si procederà al recupero coattivo del credito in sede giudiziale, con aggravio di spese legali e interessi di mora.
Distinti saluti,
[NOME_AZIENDA]
[LEGALE_RAPPRESENTANTE]`
  });
  const handleModelContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setModelContents({
      ...modelContents,
      [activeModel]: e.target.value
    });
  };
  const handleAddEmail = (type: string) => {
    if (newEmail && emailCopies[type].length < 10) {
      setEmailCopies({
        ...emailCopies,
        [type]: [...emailCopies[type], newEmail]
      });
      setNewEmail('');
    }
  };
  const handleRemoveEmail = (type: string, index: number) => {
    setEmailCopies({
      ...emailCopies,
      [type]: emailCopies[type].filter((_, i) => i !== index)
    });
  };
  const handleSaveModel = () => {
    // Logica per salvare il modello
    alert(`Modello ${activeModel} salvato con successo`);
  };
  const renderEmailCopies = (type: string) => {
    return <div className="mt-4" data-id="element-1350">
        <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1351">
          Indirizzi Email in Copia (max 10)
        </label>
        <div className="flex flex-wrap gap-2 mb-3" data-id="element-1352">
          {emailCopies[type].map((email, index) => <div key={index} className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center text-sm" data-id="element-1353">
              <span data-id="element-1354">{email}</span>
              <button type="button" onClick={() => handleRemoveEmail(type, index)} className="ml-1 text-blue-600 hover:text-blue-800" data-id="element-1355">
                <XIcon className="h-4 w-4" data-id="element-1356" />
              </button>
            </div>)}
        </div>
        <div className="flex" data-id="element-1357">
          <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} placeholder="Aggiungi email..." className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md rounded-r-none" data-id="element-1358" />
          <Button type="button" onClick={() => handleAddEmail(type)} className="mt-1 rounded-l-none" disabled={emailCopies[type].length >= 10} data-id="element-1359">
            <PlusIcon className="h-4 w-4" data-id="element-1360" />
          </Button>
        </div>
      </div>;
  };
  const inScadenzaTab = <div data-id="element-1361">
      <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1362">
        Notifica In Scadenza (Promemoria preventivo)
      </h4>
      <textarea rows={10} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md font-mono" value={modelContents.inScadenza} onChange={handleModelContentChange} data-id="element-1363"></textarea>
      {renderEmailCopies('inScadenza')}
    </div>;
  const amichevoleTab = <div data-id="element-1364">
      <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1365">
        Sollecito Amichevole (Primo Sollecito)
      </h4>
      <textarea rows={10} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md font-mono" value={modelContents.amichevole} onChange={handleModelContentChange} data-id="element-1366"></textarea>
      {renderEmailCopies('amichevole')}
    </div>;
  const formaleTab = <div data-id="element-1367">
      <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1368">
        Sollecito Formale (Secondo Sollecito)
      </h4>
      <textarea rows={10} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md font-mono" value={modelContents.formale} onChange={handleModelContentChange} data-id="element-1369"></textarea>
      {renderEmailCopies('formale')}
    </div>;
  const duroTab = <div data-id="element-1370">
      <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1371">
        Sollecito Duro (Terzo Sollecito)
      </h4>
      <textarea rows={10} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md font-mono" value={modelContents.duro} onChange={handleModelContentChange} data-id="element-1372"></textarea>
      {renderEmailCopies('duro')}
    </div>;
  const pecTab = <div data-id="element-1373">
      <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1374">PEC Ufficiale</h4>
      <textarea rows={15} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md font-mono" value={modelContents.pec} onChange={handleModelContentChange} data-id="element-1375"></textarea>
      {renderEmailCopies('pec')}
    </div>;
  return <Card data-id="element-1376">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1377">
        Modelli Predefiniti Solleciti
      </h3>
      <div className="space-y-6" data-id="element-1378">
        <Tabs tabs={[{
        id: 'inScadenza',
        name: 'In Scadenza',
        content: inScadenzaTab
      }, {
        id: 'amichevole',
        name: 'Amichevole',
        content: amichevoleTab
      }, {
        id: 'formale',
        name: 'Formale',
        content: formaleTab
      }, {
        id: 'duro',
        name: 'Duro',
        content: duroTab
      }, {
        id: 'pec',
        name: 'PEC',
        content: pecTab
      }]} defaultTab={activeModel} data-id="element-1379" />
        <div className="flex justify-end" data-id="element-1380">
          <Button type="button" onClick={handleSaveModel} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1382" />} data-id="element-1381">
            Salva Modello
          </Button>
        </div>
      </div>
    </Card>;
}